module.exports = __webpack_public_path__ + "static/img/94065B_2_3_R_2020210_fit.dd52b48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/94065B_2_3_R_2020210_fit.png
// module id = Kal8
// module chunks = 0